import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import QueryString from 'query-string';
import { rules, Form, Input } from 'react-validation/lib/build/validation.rc';
import { initRules } from 'utils/ValidateUtils';
import { login, saveAuthData } from 'utils/MemberUtils';
import MemberFormDefaultMessage from 'constants/MemberFormDefaultMessage';

class Login extends Component {
  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  state = {
    loginFailed: false
  }

  componentWillMount() {
    _.assign(rules, initRules((message) => <span className="Form-control-errorMessage">{message}</span>));
  }

  _onSubmitForm(event) {
    event.preventDefault();

    if (this._isFormValid()) {
      const {
        config: {
          affiliate: {
            expiredTime: { member: expire = 1800 } = {}
          }
        } = {}
      } = this.context;

      const { components } = this.form;
      const formData = _.mapValues(components, 'state.value');
      const memberData = _.mapKeys(formData, (value, key) => _.toLower(key));

      login(memberData).then((res) => {
        const { member, token } = res;
        if (token) {
          saveAuthData({ member, token }, expire);
          const href = QueryString.parse(location.search);
          const { redirect = '/' } = href;

          location.href = decodeURIComponent(redirect);
        }
      }).catch(() => {
        this.setState({ loginFailed: true });
      });
    }
  }

  _isFormValid() {
    return _.isEmpty(this.form.validateAll());
  }

  render() {
    const { loginFailed } = this.state;

    return (
      <Form className="Form Form-center" ref={form => this.form = form} onSubmit={(event) => this._onSubmitForm(event)}>
        { loginFailed &&
          <div className="Form-center--header">
            <div className="Notification Notification--error">
              <div className="Notification-message">Login failed. Please try again.</div>
            </div>
          </div>
        }
        <div className="Form-center--body">
          <div className="Form-control">
            <Input className="Form-control-input"
              validations={['required', 'email']}
              value=""
              name="emailAddress"
              errorClassName="Form-control-input--error"
              placeholder="email *"
            />
          </div>
          <div className="Form-control">
            <Input className="Form-control-input"
              validations={['required']}
              value=""
              name="password"
              type="password"
              errorClassName="Form-control-input--error"
              placeholder="password *"
            />
          </div>
        </div>
        <div className="Form--footer Form-center--footer">
          <div className="Form-hint">{MemberFormDefaultMessage.REGISTER_HINT} <a href="/register" >Register</a></div>
          <div className="Form-hint"><a href="/forget-password">{MemberFormDefaultMessage.FORGOT_PASSWORD_HINT}</a></div>
          <button className="Form-submitBtn">LOGIN</button>
        </div>
      </Form>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./app/components/membership/Login.js